import * as ROUTES from './ROUTES';

export const MENU_HOME = {
  icon: 'mdi-home-outline',
  label: ['Home'],
  route: ROUTES.ROUTE_HOME.path,
};

export const MENU_PEDIDO = {
  icon: 'mdi-clipboard-text-outline ',
  label: ['Pedido'],
  route: ROUTES.ROUTE_PEDIDO.path,
};

export const MENU_SINCRONIZAR = {
  icon: 'mdi-cached  ',
  label: ['Sincronizar'],
  route: ROUTES.ROUTE_SINCRONIZAR.path,
};

export const MENU_PRODUTOS = {
  icon: 'mdi-package-variant-closed   ',
  label: ['Produtos'],
  route: ROUTES.ROUTE_PRODUTOS.path,
};

export const MENU_CLIENTES = {
  icon: 'mdi-account-group   ',
  label: ['Clientes'],
  route: ROUTES.ROUTE_CLIENTES.path,
};

export const MENU_CLIENTES_PRECADASTRO = {
  icon: 'mdi-account-plus-outline',
  label: ['Clientes Pré-Cadastro'],
  route: ROUTES.ROUTE_CLIENTES_LISTA_PRECADASTRO.path,
};

export const MENU_DIVERSOS = {
  icon: 'mdi-web    ',
  label: ['Diversos'],
  route: ROUTES.ROUTE_DIVERSOS.path,
};

// export const MENU_CADASTRO_PEDIDO = {
//   icon: 'mdi-clipboard-text-outline ',
//   label: ['Cadastro Pedido'],
//   route: ROUTES.ROUTE_CADASTRO_PEDIDO.path,
// };

// ORDEM DO MENU

export default [
  MENU_HOME,
  MENU_PEDIDO,
  MENU_SINCRONIZAR,
  MENU_PRODUTOS,
  MENU_CLIENTES,
  MENU_CLIENTES_PRECADASTRO,
  MENU_DIVERSOS,
  // MENU_CADASTRO_PEDIDO,
];

export function menuMapper(componentInstance, menus) {
  return [].concat(menus).map((menu) => ({
    ...menu,
    label: String(...menu.label),
  }));
}
